import { render, staticRenderFns } from "./empleoeditor.vue?vue&type=template&id=677dc388"
import script from "./empleoeditor.vue?vue&type=script&lang=js"
export * from "./empleoeditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports